module.exports = __webpack_public_path__ + "static/testimonials-bg_2x-2cf1961bd6340dda236907f1e8f63d9f.png";